module.exports = __webpack_public_path__ + "img/fubu.af074e1c.png";